let routerMap = [
  {
    path: "/",
    name: "overload",
    component: () => import("@/views/WebViews/overload/overload"),
  },
  {
    path: "*",
    name: "404",
    component: () => import("@/components/Error/404.vue"),
  },
  {
    path: "/network-error",
    name: "network-error",
    component: () => import("@/components/Error/NetWork.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/WebViews/loginWeb"),
  },
  {
    path: "/method",
    name: "method",
    component: () => import("@/views/WebViews/User/LoginMethod"),
  },
  {
    path: "/userLogin",
    name: "userLogin",
    component: () => import("@/views/WebViews/User/userLogin"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/WebViews/User/register"),
  },
  {
    path: "/home",
    name: "home",
    redirect: "/MrBoxHome",
    component: () => import("@/views/WebViews/Home/home"),
    children: [
      {
        path: "/MyBox",
        name: "MyBox",
        component: () => import("@/views/WebViews/Home/MyBox"),
      }, //废弃
      {
        path: "/MrBoxHome",
        name: "MrBoxHome",
        redirect: "/UnBoxs",
        component: () => import("@/views/WebViews/MrBoxHome/MrBox"),
        children: [
          {
            path: "/UnBoxs",
            name: "UnBoxs",
            component: () =>
              import("@/views/WebViews/MrBoxHome/Unboxs/UnboxsPags"),
          },
          {
            path: "/MakeBoxs",
            name: "MakeBoxs",
            component: () =>
              import("@/views/WebViews/MrBoxHome/MakeBoxs/MakeBoxs"),
          },
          {
            path: "/Repository",
            name: "Repository",
            redirect: "/Apple",
            component: () =>
              import("@/views/WebViews/MrBoxHome/Repository/Repository"),
            children: [
              {
                path: "/Apple",
                name: "Apple",
                component: () =>
                  import("@/views/WebViews/MrBoxHome/Repository/Apple/Apple"),
              },
              {
                path: "/Rolex",
                name: "Rolex",
                component: () =>
                  import("@/views/WebViews/MrBoxHome/Repository/Rolex/Rolex"),
              },
            ],
          },
        ],
      },

      {
        path: "/MineFirst",
        name: "MineFirst",
        redirect: "/Mines",
        component: () => import("@/views/WebViews/Mine/MineFirstScreen"),
        children: [
          {
            path: "/Mines",
            name: "Mines",
            component: () => import("@/views/WebViews/Mine/Mines"),
          },

          {
            path: "/NftGoods",
            name: "NftGoods",
            component: () => import("@/views/WebViews/Mine/NftGoods"),
          },
          {
            path: "/Games",
            name: "Games",
            component: () => import("@/views/WebViews/Mine/Games"),
          },
        ],
      },
      {
        path: "/MinesDetails",
        name: "MinesDetails",
        component: () => import("@/views/WebViews/Mine/MineDetailsPags"),
      },
      {
        path: "/MinesNftDetails",
        name: "MinesNftDetails",
        component: () => import("@/views/WebViews/Mine/MinesNftDetails"),
      },
      {
        path: "/Activity",
        name: "Activity",
        component: () => import("@/views/WebViews/Nfts/NftsPags"),
      },
      {
        path: "/Market",
        name: "Market",
        component: () => import("@/views/WebViews/Market/MarketPags"),
      },
      //nfts抽奖
      {
        path: "/Raffle",
        name: "Raffle",
        component: () => import("@/views/WebViews/Nfts/Raffle/Raffle"),
      },
      //nfts抽奖详情
      {
        path: "/RaffleCar",
        name: "RaffleCar",
        component: () => import("@/views/WebViews/Nfts/Raffle/RaffleCar"),
      },
      //nfts详情页
      {
        path: "/Details",
        name: "Details",
        component: () =>
          import("@/views/WebViews/Nfts/Details/NftsDetailsPage"),
      },
      //nfts详情页
      {
        path: "/detailsPage",
        name: "detailsPage",
        component: () => import("@/common/ListDetails/detailsPage"),
      },
      //交易中心
      {
        path: "/Dealings",
        name: "Dealings",
        component: () => import("@/views/WebViews/Nfts/Dealings/DealingsPags"),
      },
      //合成
      {
        path: "/Synthesize",
        name: "Synthesize",
        component: () => import("@/views/WebViews/Nfts/Synthesize/Synthesize"),
      },
      //合成
      {
        path: "/SynthesizeCar",
        name: "SynthesizeCar",
        component: () =>
          import("@/views/WebViews/Nfts/Synthesize/SynthesizeCar"),
      },
      //兑换
      {
        path: "/Convertible",
        name: "Convertible",
        component: () =>
          import("@/views/WebViews/Nfts/Convertible/Convertible"),
      },
      {
        path: "/ConvertibleCar",
        name: "ConvertibleCar",
        component: () =>
          import("@/views/WebViews/Nfts/Convertible/ConvertibleCar"),
      },
      //个人中心
      {
        path: "/MyInfo",
        name: "MyInfo",
        component: () => import("@/views/WebViews/MyInfo/MyInfo"),
      },
      //个人资料修改
      {
        path: "/UserInformation",
        name: "UserInformation",
        component: () =>
          import("@/views/WebViews/MyInfo/UserInformation/UserInformation"),
      },
      //修改组件
      {
        path: "/EditMian",
        name: "EditMian",
        component: () =>
          import("@/views/WebViews/MyInfo/UserInformation/Edit/EditMian"),
      },
      //收货地址
      {
        path: "/DeliveryAddress",
        name: "DeliveryAddress",
        component: () =>
          import(
            "@/views/WebViews/MyInfo/UserInformation/Edit/DeliveryAddress/DeliveryAddress"
          ),
      },
      //修改、添加地址
      {
        path: "/addAddress",
        name: "addAddress",
        component: () =>
          import(
            "@/views/WebViews/MyInfo/UserInformation/Edit/DeliveryAddress/addAddress"
          ),
      },
      //我的nft
      {
        path: "/MyNft",
        name: "MyNft",
        component: () => import("@/views/WebViews/MyInfo/MyNft/MyNft"),
      },
      //我的商品
      {
        path: "/MyGoods",
        name: "MyGoods",
        component: () => import("@/views/WebViews/MyInfo/MyGoods/MyGoods"),
      },
      //寄存柜
      {
        path: "/Locker",
        name: "Locker",
        component: () => import("@/views/WebViews/MyInfo/Locker/Locker"),
      },
      //寄存柜提取物品
      {
        path: "/ConfirmationOrde",
        name: "ConfirmationOrde",
        component: () =>
          import("@/views/WebViews/MyInfo/ConfirmationOrde/ConfirmationOrde"),
      },
      //我的钱包
      {
        path: "/MyWallet",
        name: "MyWallet",
        component: () => import("@/views/WebViews/MyInfo/MyWallet/MyWallet"),
      },
      //我的订单
      {
        path: "/MyOrder",
        name: "MyOrder",
        component: () => import("@/views/WebViews/MyInfo/MyOrder/MyOrder"),
      },
      //我的会员
      {
        path: "/Member",
        name: "Member",
        component: () => import("@/views/WebViews/MyInfo/Member/Member"),
      },
      //我的会员规则明细
      {
        path: "/MemberDetails",
        name: "MemberDetails",
        component: () =>
          import("@/views/WebViews/MyInfo/Member/MemberDetails/MemberDetails"),
      },
      {
        path: "/RankBreakdown",
        name: "RankBreakdown",
        component: () =>
          import("@/views/WebViews/MyInfo/Member/RankBreakdown/RankBreakdown"),
      },
      //联系我们
      {
        path: "/ContactUs",
        name: "ContactUs",
        component: () => import("@/views/WebViews/MyInfo/ContactUs/ContactUs"),
      },
      //版本
      {
        path: "/Versions",
        name: "Versions",
        component: () => import("@/views/WebViews/MyInfo/Versions/Versions"),
      },
      //公告
      {
        path: "/Announcement",
        name: "Announcement",
        component: () => import("@/views/WebViews/Announcement/Announcement"),
      },
      //公告详情
      {
        path: "/announcementDetails",
        name: "announcementDetails",
        component: () =>
          import("@/views/WebViews/Announcement/common/announcementDetails"),
      },
    ],
  },
  {
    path: "/SearchPage",
    name: "SearchPage",
    component: () => import("@/components/SearchPage/SearchPage"),
  },
  //保存草稿
  {
    path: "/DraftBox",
    name: "DraftBox",
    component: () => import("@/views/WebViews/MrBoxHome/MakeBoxs/DraftBox/DraftBox"),
  },
  //我的盒子详情页
  {
    path: "/MyBoxesDetails",
    name: "MyBoxesDetails",
    component: () =>
      import(
        "@/views/WebViews/MrBoxHome/MakeBoxs/MyBoxesDetails/MyBoxesDetails"
      ),
  },
  //为他人做盒子
  {
    path: "/OthersMadeBoxs",
    name: "OthersMadeBoxs",
    component: () =>
      import("@/views/WebViews/MrBoxHome/MakeBoxs/NewlyMade/OthersMadeBoxs"),
  },
   //为自己做盒子
   {
    path: "/YourselfMadeBoxs",
    name: "YourselfMadeBoxs",
    component: () =>
      import("@/views/WebViews/MrBoxHome/MakeBoxs/NewlyMade/YourselfMadeBoxs"),
  },
  //仓库收藏页
  {
    path: "/Collect",
    name: "Collect",
    component: () =>
      import("@/views/WebViews/MrBoxHome/Repository/Collect/Collect"),
  },
  //开盒详情页
  {
    path: "/UnBoxsDetails",
    name: "UnBoxsDetails",
    component: () =>
      import(
        "@/views/WebViews/MrBoxHome/UnBoxDetails/UnBoxDetails"
      ),
  },
   //开盒详情页
   {
    path: "/UnBoxsDetailsTow",
    name: "UnBoxsDetailsTow",
    component: () =>
      import(
        "@/views/WebViews/MrBoxHome/UnBoxDetails/UnBoxDetailsTo"
      ),
  },
  //
  {
    path: "/RepositoryGoodsDetails",
    name: "RepositoryGoodsDetails",
    component: () =>
      import("@/views/WebViews/MrBoxHome/Repository/GoodsDetails/GoodsDetails"),
  },
  {
    path: "/buyDetails",
    name: "buyDetails",
    component: () => import("@/views/WebViews/goodsDetails/buyDetails"),
  },

  // {
  //     path: '/Language',
  //     component: LanGuage
  // },
  // {
  //     path: '/login',
  //     component: loginWeb3
  // },
];

export default routerMap;
